// Keep these statements and the archived notice in sync. Every wording change
// requires a new version; the server must validate and retain the same version.
export const PRIVACY_VERSION = 'MRF-ADESIONE-2026-10-03.1'
export const PRIVACY_NOTICE_URL = '/privacy/versions/MRF-ADESIONE-2026-10-03.1.pdf'
export const PRIVACY_NOTICE_SHA256 = 'be9a467f895863178c6dee2695da9c5f69a080c90da000407920e3891b295ef6'
export const PRIVACY_API_BASE_URL = 'https://api.movimentorivoluzionefiscale.it/v2'
export const PRIVACY_APPLICATION_STATEMENT = 'Dichiaro di aver letto l’informativa privacy e acconsento esplicitamente al trattamento dei dati che possono rivelare le mie opinioni politiche, esclusivamente per esaminare la mia richiesta di adesione al Movimento Rivoluzione Fiscale e comunicarmene l’esito.'
export const PRIVACY_COMMUNICATIONS_STATEMENT = 'Acconsento a ricevere via email aggiornamenti sulle iniziative e sulle attività del Movimento Rivoluzione Fiscale, anche mediante il trattamento dei dati che possono rivelare le mie opinioni politiche. Questa scelta è facoltativa e non condiziona la richiesta di adesione.'

// This is evidence of the client's affirmative choices, not proof of storage.
// The API must add its own receipt timestamp and save the complete record.
export function buildPrivacyRecord(applicationConsent, communicationsConsent, submittedAt = new Date().toISOString()) {
  if (applicationConsent !== true) throw new Error('Il consenso per esaminare la domanda deve essere esplicito.')
  return {
    schemaVersion: 1,
    noticeVersion: PRIVACY_VERSION,
    noticeUrl: PRIVACY_NOTICE_URL,
    noticeSha256: PRIVACY_NOTICE_SHA256,
    noticeAcknowledged: true,
    applicationConsent: true,
    applicationStatement: PRIVACY_APPLICATION_STATEMENT,
    communicationsConsent: communicationsConsent === true,
    communicationsStatement: PRIVACY_COMMUNICATIONS_STATEMENT,
    clientSubmittedAt: submittedAt,
    method: 'unchecked-checkboxes-and-submit',
  }
}
